import app from '../../App';

export default class PricingHelper {
    constructor($log, $http, Info, PlansService) {

        'ngInject';
        this._$http = $http;
        this.Info = Info;
        this.PlansService = PlansService;
        this.plans = [];
    }

    plansReady(){
        return this.plans.length>0?true:false;
    }

    getPlans(){
        this.PlansService.getNewBillingPlans().then((response)=> {
            this.plans = response.data.Result;
            console.log("Pricing plans downloaded");
        });
    }

    getCurrentPlan(displays = 1) {
        if (this.plans.length > 0) {
            return this.PlansService.generatePlanServiceValueObject(this.plans
                .sort((a, b) => a.MaxDevices - b.MaxDevices)
                .filter((value) => value.MaxDevices >= displays).shift());
        }
    }

    getLicensePrice(plan, displays = 1) {
        if (this.plans.length > 0) {
            let currentPlan = this.getCurrentPlan(displays);
            switch (plan) {
                case 'monthly':
                    return currentPlan.basePrice + displays * currentPlan.pricePerLicense;
                    break;
                case 'annual':
                    return (currentPlan.basePrice + displays * currentPlan.pricePerLicense) * (1 - currentPlan.percentageOffLicensesForAnnual);
                    break;
            }
        }
    }

    getDevicePrice(displays = 1) {
        if (this.plans.length > 0) {
            return this.getCurrentPlan(displays).devicePrice;
        }
    }

    getTotalLicense(plan, displays = 1) {
        if (this.plans.length > 0) {
            switch (plan) {
                case 'monthly':
                    return this.getLicensePrice(plan, displays);
                    break;
                case 'annual':
                    return this.getLicensePrice(plan, displays) * 12;
                    break;
            }
        }
    }

    getTotalLicenseDiscount(plan, displays = 1) {
        if (this.plans.length > 0) {
            let currentPlan = this.getCurrentPlan(displays);
            switch (plan) {
                case 'monthly':
                    return 0;
                    break;
                case 'annual':
                    return 12 * (currentPlan.basePrice + displays * currentPlan.pricePerLicense) * (currentPlan.percentageOffLicensesForAnnual);
            }
        }
    }

    getTotalDevices(displays = 1, devices = 0) {
        if (this.plans.length > 0) {
            return this.getDevicePrice(displays) * devices;
        }
    }

    getTotalDevicesDiscount(plan, displays=1, devices = 0) {
        if (this.plans.length > 0) {
            let currentPlan = this.getCurrentPlan(displays);
            switch (plan) {
                case 'annual':
                    return currentPlan.percentageOffDevicesForAnnual * devices * currentPlan.devicePrice;
                    break;
                case 'monthly':
                    return 0;
                    break;
            }
        }
    }

};

app.service('PricingHelper', PricingHelper);


// WEBPACK FOOTER //
// ./src/js/helpers/checkout-flow/PricingHelper.js